import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'

@jsonClass('ServiceProviderVersion')
export class ServiceProviderVersion {
	@jsonProperty(String)
	versionName: string
	@jsonProperty(String)
	comment: string

	constructor(init?: Partial<ServiceProviderVersion>) {
		assignCommonProperties(this, init)
	}

	getSafeName() {
		if (this.versionName.match(/^[a-z_]/)) return this.versionName
		return `v_${this.versionName}`
	}
}
